import React, { useCallback } from 'react';
import classNames from 'classnames';

import { FieldHint, Input } from '@atlas/ui';

import Field from '../../Field';

import VerifyBlock from './VerifyBlock';

const EmailWithVerification = ({ field, onBlur, onChange, onFocus }) => {
  const {
    active,
    autofocus,
    className,
    disabled,
    errors,
    hint,
    isModifiable = true,
    label,
    name,
    placeholder,
    touched,
    uiTitleClassName,
    value,
  } = field;
  const inputValue = value ?? '';
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);
  const error = touched && errors[0];
  const success = touched && !error;
  const isDisabled = disabled || !isModifiable;

  return (
    <div
      className={classNames('email-with-verification', {
        'is-verified': isDisabled && !!hint,
      })}
    >
      <Field options={field}>
        <Input
          active={active}
          autoFocus={autofocus}
          className={className}
          disabled={isDisabled}
          error={error}
          inputMode="email"
          label={label}
          name={name}
          onBlur={onBlur}
          onChange={changeHandler}
          onFocus={onFocus}
          placeholder={placeholder}
          success={success}
          touched={touched}
          type="email"
          uiTitleClassName={uiTitleClassName}
          value={inputValue}
        />
        <FieldHint hint={hint} showOnClick />
      </Field>
      <VerifyBlock />
    </div>
  );
};

export default EmailWithVerification;
